// import moment from 'moment';
// import { date as dateTransform } from '~/network/mainClient/common/transforms/responses';
// import config from '~/config';

export const notice = (data) => {
    const result = {
        investments: data.investment_request_notice,
        deals: data.trade_order_notice,
    };
    return result;
};
